export const productCategories = [
  {
    path: "?filter.category.%24in=showers",
    label: "Showers",
    value: "showers",
    sidebarImage: "/shower-thumbnail.jpg",
    carouselImage: "/shower-md.jpg",
  },
  {
    path: "?filter.category.%24in=baths",
    label: "Baths",
    value: "baths",
    sidebarImage: "/bath-thumbnail.jpg",
    carouselImage: "/bath-md.jpg",
  },
  {
    path: "?filter.category.%24in=mirrors",
    label: "Mirrors",
    value: "mirrors",
    sidebarImage: "/mirror-thumbnail.jpg",
    carouselImage: "/mirror-md.jpg",
  },
  {
    path: "?filter.category.%24in=tiles",
    label: "Tiles",
    value: "tiles",
    sidebarImage: "/tile-thumbnail.jpg",
    carouselImage: "/tile-md.jpg",
  },
  {
    path: "?filter.category.%24in=toilets",
    label: "Toilets",
    value: "toilets",
    sidebarImage: "/toilet-md.jpg",
    carouselImage: "/toilet-md.jpg",
  },
] as const satisfies {
  path: string;
  label: string;
  value: string;
  sidebarImage: string;
  carouselImage: string;
}[];
